// extracted by mini-css-extract-plugin
export default {"pointsView":"PointsView_pointsView__vh9+s","scoreIcon":"PointsView_scoreIcon__ivEEl","pointsActive":"PointsView_pointsActive__wchVg"};